import { makeStyles } from '@mui/styles';

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export const useStyles = makeStyles((theme: any) => ({
  helperTextRoot: { marginLeft: '14px', marginTop: 0, fontSize: '11px' },
  buttonRoot: {
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  ivalidInputLabel: {
    color: theme.palette.danger
  },
  inputLabel: {
    marginBottom: theme.spacing(0.75),
    fontSize: theme.spacing(2)
  },
  disableShadowInputDom: {
    '& input[type=number]': {
      '-moz-appearance': 'textfield'
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    }
  }
}));
